import React, { Component } from 'react';
import { connect } from 'react-redux';
import { message } from 'antd';
import ScenarioPageComponent from '../components/ScenarioPage';
import baseActions from '../actions';
import {
  getSetSequence, buildFilters, handleClickToViewScenario,
} from '../helpers';
import {
  SCENARIOS, PERSIST_PARAMS, RAW_DATA_TYPES, ARCHIVE_SCENARIO, UNARCHIVE_SCENARIO, DELETE_SCENARIO, REPLACE_PLAN,
} from '../plannerConfig';
import {
  SCENARIO_CREATE,
  SCENARIO_UPDATE,
} from '../constants/text.constants';
import { ACTIVE_PLAN_ID } from '../constants/app.constants';

const mapStateToProps = state => ({
  [SCENARIOS]: state[SCENARIOS],
  [PERSIST_PARAMS]: state[PERSIST_PARAMS].data,
  [RAW_DATA_TYPES]: state[RAW_DATA_TYPES].data,
});

const mapDispatchToProps = {
  get: baseActions.get,
  put: baseActions.put,
  post: baseActions.post,
  set: baseActions.set,
};

const gridConfigTop = {
  includeItemSelection: false,
  includeFilter: true,
  includePagination: false,
  includeRowCounts: false,
  includeEditDeleteCell: false,
  includeToolbar: false,
  hiddenColumns: ['user', 'isReplan'],
};

const gridConfigBottom = {
  includeFilter: false,
  includeRowCounts: false,
  includeItemSelection: false,
  includePagination: false,
  includeEditDeleteCell: false,
  includeToolbar: false,
  hiddenColumns: ['user', 'isReplan'],
};

// TODO: Ideally this should be returned from backend. Hard-coded in frontend for
// time being when backend resource is unavailable.
const meta = {
  columns: [
    { name: '__FUNC_COLUMN' },
    {
      name: 'name', display_name: 'Name', type: 'string', enable_link: true, showEditIcon: true,
    },
    {
      name: 'id', display_name: 'ID', type: 'string', width: 100,
    },
    { name: 'comment', display_name: 'Comment', type: 'string' },
    {
      name: 'owner', display_name: 'Owner', type: 'string',
    },
    { name: 'fromDate', display_name: 'From Date', type: 'date' },
    { name: 'toDate', display_name: 'To Date', type: 'date' },
  ],
};

class ScenarioPage extends Component {
  state = {
    selectedScenario: {},
    showArchived: false,
    queryParameters: {
      offset: 0,
      ordering: null,
      filters: {},
      // limit: 5,
    },
  };

  componentDidMount() {
    const { queryParameters } = this.state;
    getSetSequence(
      this.props,
      [[SCENARIOS]],
      undefined,
      { queryParameters: { ...queryParameters } },
    );
  }

  getScenarios = (showArchived, callback) => {
    const { get } = this.props;
    const { queryParameters: { filters, ...rest } } = this.state;
    get(
      [SCENARIOS],
      {
        routeParams: {
          showArchived,
          queryParameters: {
            ...rest,
            ...buildFilters(filters),
          },
        },
        callback,
      },
    );
  }

  updateConfig = ({ limit, filters, ...config }) => {
    const { showArchived, queryParameters } = this.state;
    const newQueryParams = { ...queryParameters, ...config };

    if (filters) {
      const appliedFilters = { ...filters };
      Object.keys(filters).forEach((key) => {
        if (appliedFilters[key].filterTerm === '') delete appliedFilters[key];
      });

      newQueryParams.filters = appliedFilters;
    }

    if (limit) newQueryParams.limit = limit;

    this.setState({
      queryParameters: newQueryParams,
    }, () => {
      this.getScenarios(showArchived);
    });
  }

  handleChangeSplitPanel = (size) => {
    const { set, persistParams } = this.props;
    set([PERSIST_PARAMS], { ...persistParams, scenarioSplitPaneSize: size });
  }

  handleToggleShowArchive = () => {
    const { showArchived: originShowArchived } = this.state;
    this.setState({ showArchived: !originShowArchived }, () => {
      const { showArchived } = this.state;
      this.getScenarios(showArchived);
    });
  }

  handleSelect = (checkbox) => {
    const { selectedScenario } = this.state;
    const { rowData, checked } = checkbox;
    const newObj = { ...selectedScenario };

    if (checked) {
      newObj[rowData.id] = rowData;
    } else if (newObj[rowData.id]) {
      delete newObj[rowData.id];
    }

    this.setState({ selectedScenario: newObj });
  }

  handleRemoveAllScenario = () => {
    this.setState({ selectedScenario: {} });
  }

  handleSubmitToCreateScenario = (formData) => {
    const { post } = this.props;
    const { showArchived } = this.state;
    const {
      name, comment, copyFrom, dateRange,
    } = formData;
    const data = {
      name,
      comment,
      sourceScenarioId: copyFrom,
      fromDate: dateRange.start,
      toDate: dateRange.end,
    };

    post(
      [SCENARIOS],
      {
        routeParams: {},
        body: data,
        callback: (cbData) => {
          this.getScenarios(showArchived, () => {
            message.success(SCENARIO_CREATE(cbData.name));
          });
        },
      },
    );
  };

  handleMakeChangesToSelectedScenario = (endpoint) => {
    const { put } = this.props;
    const { selectedScenario, showArchived } = this.state;
    const scenarioIds = Object.values(selectedScenario).map(scenario => scenario.id);
    const callback = () => {
      this.handleRemoveAllScenario();
      this.getScenarios(showArchived);
    };

    put(endpoint, { body: { scenarioIds }, callback });
  };

  handleReplaceActivePlan = () => {
    const { post } = this.props;
    const { showArchived, selectedScenario } = this.state;
    const scenarioId = Object.values(selectedScenario)[0].id;
    const callback = () => {
      this.handleRemoveAllScenario();
      this.getScenarios(showArchived);
    };
    post([REPLACE_PLAN],
      {
        routeParams: {
          scenario: scenarioId,
          scenarioDest: ACTIVE_PLAN_ID,
        },
        callback,
      });
  }

  handleSetArchiveSelectedScenario = setArchive => this.handleMakeChangesToSelectedScenario(
    [(setArchive ? ARCHIVE_SCENARIO : UNARCHIVE_SCENARIO)],
  );

  handleClickDeleteSelectedScenario = () => this.handleMakeChangesToSelectedScenario(
    [DELETE_SCENARIO],
  );

  _handleClickToViewScenario = (data, isDashboard) => {
    handleClickToViewScenario(data, isDashboard, this.props);
  };

  handleSubmitToUpdateScenario = (formData) => {
    const { put } = this.props;
    const { showArchived } = this.state;
    // Bkt-Grid changes all the lookup field from id to a name in string, but the backend
    // requires the numeric id. This is to modify the string back to numeric id so that
    // the backend accepts the data.
    const toSentFormData = { ...formData };

    put(
      [SCENARIOS],
      {
        routeParams: { id: formData.id },
        body: toSentFormData,
        callback: (cbData) => {
          this.getScenarios(showArchived, () => {
            message.success(SCENARIO_UPDATE(cbData.name));
          });
        },
      },
    );
  }

  // A hack to bkt-grid to insert custom UI - please refer to UseBktGrid component.
  scenariosMod = (scenarioList, funcCol) => (
    scenarioList
      .map(({
        id, name, fromDate, toDate, ...rest
      }) => ({
        __FUNC_COLUMN: { customUI: funcCol },
        id,
        key: name,
        name,
        ...rest,
        fromDate: (id > 0) && fromDate,
        toDate: (id > 0) && toDate,
      }))
  );

  render() {
    const { selectedScenario, queryParameters } = this.state;
    const {
      scenarios: { loadingQueue, data }, persistParams,
    } = this.props;
    const { results, ...rest } = data;
    const scenariosWithId = {
      ...rest,
      results: results ? this.scenariosMod(results, 'customCheckbox') : [],
    };
    const selectedScenariosWithId = this.scenariosMod(Object.values(selectedScenario), 'minusButton');

    return (
      <ScenarioPageComponent
        scenarios={results}
        isLoading={loadingQueue.length > 0}
        dataView={scenariosWithId}
        selectedScenarios={selectedScenariosWithId}
        gridConfigTop={{ ...gridConfigTop, ...queryParameters }}
        gridConfigBottom={gridConfigBottom}
        onSelect={this.handleSelect}
        onClickRemoveSelected={this.handleRemoveAllScenario}
        onSubmitToCreateScenario={this.handleSubmitToCreateScenario}
        onSubmitToUpdateScenario={this.handleSubmitToUpdateScenario}
        onClickToViewScenario={this._handleClickToViewScenario}
        onClickToggleShowArchive={this.handleToggleShowArchive}
        onClickSetArchiveSelected={this.handleSetArchiveSelectedScenario}
        onClickReplaceActivePlan={this.handleReplaceActivePlan}
        onClickDeleteSelectedScenario={this.handleClickDeleteSelectedScenario}
        onChangeSplitPanel={this.handleChangeSplitPanel}
        checkedState={selectedScenario}
        updateConfig={this.updateConfig}
        meta={meta}
        persistParams={persistParams}
      />
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ScenarioPage);
